import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PopupBundleOfferCon from '../../../PopupBundleOfferCon';
import SlideoutBundleProduct from './product';

import { MBox } from '../../../../../atoms/MBox';
import MFlexbox from '../../../../../atoms/MFlexbox';

import IconAdd from '../../../../../atoms/IconAdd';

import { StyledSlideoutBundlePopupWidgetCon } from './skins';
import { getSeparatedStyleValueArr } from '../../../../../helpers/style';

export default function SlideoutBundleLayout(props) {
  const {
    isMobile,
    primary,
    products,
    selectedVariantInfo,
    popupOfferHeaderStyles,
    popupOfferBottomBarStyles,
    priceDetailStyles,
    theme,
    onMinimizeClick,
    onCheckoutClick,
    onSkipClick,
    bundlePriceBarInfo,
    showDiscountCode,
    discountCodeProps,
    isBottomBarButtonActionLoading,
    ...restProps
  } = props;

  const productSeparatorPadding = getSeparatedStyleValueArr(
    isMobile ? theme.productItemMobilePadding : theme.productItemPadding,
  )
    .map((padding, i) => `${i % 2 !== 0 ? padding : 0}px`)
    .join(' ');

  return (
    <StyledSlideoutBundlePopupWidgetCon className="mr-popup-widget mr-popup-widget--bundle-popup">
      <PopupBundleOfferCon
        isMobile={isMobile}
        bundlePriceBarInfo={bundlePriceBarInfo}
        onMinimizeClick={onMinimizeClick}
        onCheckoutClick={onCheckoutClick}
        onSkipClick={onSkipClick}
        popupOfferHeaderStyles={popupOfferHeaderStyles}
        popupOfferBottomBarStyles={popupOfferBottomBarStyles}
        priceDetailStyles={priceDetailStyles}
        productsContainerPadding={theme.productsContainerPadding}
        productsContainerMargin={theme.productsContainerMargin}
        showDiscountCode={showDiscountCode}
        discountCodeProps={discountCodeProps}
        isBottomBarButtonActionLoading={isBottomBarButtonActionLoading}
      >
        {products.map((product, i) => (
          <Fragment key={product.id}>
            <SlideoutBundleProduct
              isMobile={isMobile}
              product={product}
              selectedVariant={selectedVariantInfo[i]}
              theme={theme}
              priceDetailStyles={priceDetailStyles}
              {...restProps}
            />
            {i < products.length - 1 && (
              <MFlexbox
                gap="6px"
                ai="center"
                className="mr-bundle-product-separator"
                padding={productSeparatorPadding}
              >
                <MBox className="mr-divider mr-grow" />
                <IconAdd
                  fontSize={14}
                  color="gray"
                  className="mr-bundle-add-icon"
                />
                <MBox className="mr-divider mr-grow" />
              </MFlexbox>
            )}
          </Fragment>
        ))}
      </PopupBundleOfferCon>
    </StyledSlideoutBundlePopupWidgetCon>
  );
}

SlideoutBundleLayout.propTypes = {
  isAdmin: PropTypes.bool,
  isAdminMobileTab: PropTypes.bool,
  isMobile: PropTypes.bool,
  primary: PropTypes.object,
  products: PropTypes.array,
  selectedVariantInfo: PropTypes.array,
  theme: PropTypes.object,
  bundlePriceBarInfo: PropTypes.object,
  showDiscountCode: PropTypes.bool,
  discountCodeProps: PropTypes.object,
  isBottomBarButtonActionLoading: PropTypes.bool,
  popupOfferHeaderStyles: PropTypes.object,
  popupOfferBottomBarStyles: PropTypes.object,
  priceDetailStyles: PropTypes.object,
  onMinimizeClick: PropTypes.func,
  onCheckoutClick: PropTypes.func,
  onSkipClick: PropTypes.func,
};
